import { pickBy } from "lodash";

export default class {
  init() {
    const $element = $("#shopApp");

    if ($element.length) {
      (async () => {
        const Vue = (await import("vue")).default;
        const qs = (await import("qs")).default;
        const VueSlider = (await import("vue-slider-component")).default;
        await import("vue-slider-component/theme/default.css");

        new Vue({
          components: {
            VueSlider,
          },

          data() {
            return {
              expanded: window.innerWidth > 992,
              product_cat: null,
              priceSlider: [window.mjShopApp.price_min, window.mjShopApp.price_max],
              s: "",
              orderby: null,
            };
          },

          computed: {
            formParams() {
              return pickBy({
                orderby: this.orderby,
                s: this.s,
                min_price: this.priceSlider[0],
                max_price: this.priceSlider[1],
                product_cat: this.product_cat,
              });
            },
          },

          created() {
            this.orderby = $("select[name=orderby] option:first").val();
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.get("s")) {
              this.s = urlParams.get("s");
            }

            if (urlParams.get("product_cat")) {
              this.product_cat = urlParams.get("product_cat");
            }

            if (urlParams.get("orderby")) {
              if ($(`select[name=orderby] option[value=${urlParams.get("orderby")}]`).length) {
                this.orderby = urlParams.get("orderby");
              }
            }

            if (urlParams.get("min_price")) {
              this.priceSlider[0] = parseInt(urlParams.get("min_price"));
            }

            if (urlParams.get("max_price")) {
              this.priceSlider[1] = parseInt(urlParams.get("max_price"));
            }

            window.App.aos.refreshHard();

            $(window).on("resize", () => {
              this.expanded = window.innerWidth > 992;
            });
          },

          methods: {
            search() {
              const url = `${window.location.origin}${window.location.pathname}`;

              window.location.href = `${url.substr(0, url.indexOf("page"))}?${qs.stringify(this.formParams)}`;
            },
          },
        }).$mount($element[0]);
      })();
    }
  }
}
